module.exports = __webpack_public_path__ + "static/media/cil_fax.ef7c5a8e.svg";